<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary"
                    @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary" @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button class="button btn-danger"
                    v-if="this.element && this.element.id && getPermissionSection('delete')"
                    @click="openConfirmDelete = true">
                {{ $ml.get('buttons.delete') }}
            </button>

            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <div class="block" :key="change">
            <div class="title">{{ pageTitle }}</div>
            <div class="body flex-row-wrap">
                <div :class="getClass(label)"
                     v-for="label in labels">
                    <div class="formBlock">
                        <p :class="['label', {'required' : form_required.includes(label)}]">
                            {{ form_labels[label] }}
                            <template v-if="form_required.includes(label)">*</template>
                        </p>
                        <template v-if="getTypeForm(label) === 'number'">
                            <input type="number"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'string'">
                            <div class="input disabled">
                                <template v-if="element[label]">
                                    {{ element[label] }}
                                </template>
                                <template v-else>
                                    &nbsp;
                                </template>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'date'">
                            <date-picker
                                valueType="format"
                                format="MM/DD/YYYY"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                        </template>
                        <template v-if="getTypeForm(label) === 'datetime'">
                            <date-picker
                                type="datetime"
                                valueType="format"
                                format="MM/DD/YYYY HH:mm:ss"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                        </template>
                        <template v-if="getTypeForm(label) === 'link'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'textarea'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'input'">
                            <input type="text"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="getSelectLabel(label)"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'boolean'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    v-model="element[label]"
                                    :options="selectBooleanOptions"
                                    :placeholder="form_labels[label]">
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'custom-select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="typeForm[label].label"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[typeForm[label].dictionary]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-tags'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-membership-type'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    v-model="element[label]"
                                    :value="element[label]"
                                    :options="selectMembershipTypes"
                                    :placeholder="form_labels[label]">
                                </Multiselect>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="helper p10" v-html="helpData"></div>
            </div>
        </div>

        <div class="block" :key="'discounts_'+change">
            <div class="title">Separate discounts for membership plans. If fixed value is not set discount % will be used.</div>
            <div class="body">
                <button class="button btn-primary" @click="addDiscount">Add discount</button>
                <div class="">
                    <table class="table">
                        <thead>
                        <tr>
                            <th width="40%">Membership</th>
                            <th>Discount</th>
                            <th>#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in planDiscounts[element.membership_type]">
                            <td>
                                <div class="defaultMultiselect">
                                    <Multiselect
                                        track-by="id"
                                        label="title"
                                        v-model="item.plan_id"
                                        :options="plansForDiscount"
                                        placeholder="Membership">
                                        <template v-slot:noResult>
                                            {{ $ml.get('interface.no_result') }}
                                        </template>
                                        <template v-slot:noOptions>
                                            {{ $ml.get('interface.no_options') }}
                                        </template>
                                    </Multiselect>
                                </div>
                            </td>
                            <td>
                                <input type="number" class="input" placeholder="Discount ($)" v-model="item.amount">
                            </td>
                            <td>
                                <button class="button btn-danger" @click="deleteDiscount(index)">
                                    <span class="ico-fa icon-delete"></span>
                                </button>
                            </td>

                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <ModalWindow :open="openConfirmDelete"
                     @closeModal="openConfirmDelete = false">
            <template slot="title">
                {{ $ml.get('interface.confirm_action') }}
            </template>
            <template slot="body">
                {{ $ml.get('interface.confirm_action_delete') }}
            </template>
            <template slot="buttons">
                <button class="button btn-danger" @click="deleteForm">
                    {{ $ml.get('buttons.delete') }}
                </button>
            </template>
        </ModalWindow>

    </div>
</template>

<script>
import FormDefault from "../../Utils/Page/FormDefault";
import Table from "../../Utils/Table/Table.vue";

export default {
    name: "Form",
    components: {Table},
    mixins: [FormDefault],
    data() {
        return {
            lang: this.$ml.get('pages.promo_code'),
            buttons: [
                { key: 'generate', class: 'btn-primary', function: this.generateCode },
                { key: 'generateQRCode', class: 'btn-primary', function: this.generateQRCode }
            ],

            helpData: `
            <p>Notes:</p>
            <p>USER - leave blank if there is no binding to the user (for the report)</p>
            <p>USAGE LIMIT - leave blank if there are no restrictions</p>
            <p>ACTIVATED - if set to "no" - will not allow to use</p>
            <p>START DATE and FINISH DATE - leave blank if there are no restrictions</p>
            <p>AMOUNT OF USE - shows how many times the promo code has been used</p>
            <p>GENERATE QR CODE - save progress before generating QR code</p>
            <p><b>SERVER TIMEZONE</b> - UTC</p>
            `,

            planDiscounts: {
              regular: [],
              pro: []
            },

            typeForm: {
                parent_id: 'select',
                date_start: 'datetime',
                date_finish: 'datetime',
                activated: 'boolean',
                sale: 'number',
                max_count: 'number',
                counter: 'string',
                note: 'textarea',
                description: 'textarea',
                membership_type: 'select-membership-type'
            },

            form_required: [
                'code',
            ],

            element: {
                code: null,
                date_start: null,
                date_finish: null,
                counter: '-',
                activated: true,
                membership_type: 'regular',
            },

            pageRouteList: 'promo_code',
            pageRouteEdit: 'promo_code.edit',
            pageApi: 'marketing.promo_code',
            pagePermission: 'marketing.promo_code',

            selectMembershipTypes: [
                'regular',
                'pro'
            ],
        }
    },
    computed: {
      plansForDiscount() {
        const dictionary = this.element.membership_type === 'regular'
            ? 'plan_id'
            : 'pro_plan_id'

        return this.dictionaries[dictionary]
      }
    },
    methods: {
        deleteDiscount(index) {
            this.planDiscounts[this.element.membership_type].splice(index, 1)
        },
        addDiscount() {
            this.planDiscounts[this.element.membership_type].push({
                plan_id: null,
                amount: null,
            })
        },
        setExtraData(data) {
          console.log('data', data)
            let planDiscounts = data.element.plan_discounts
            planDiscounts.map(el => {
                el.plan_id = el.plan
            })
            this.planDiscounts[data.element.membership_type] = planDiscounts
        },
        appendDataSave() {
            return {
                planDiscounts: this.planDiscounts[this.element.membership_type]
            }
        },
        generateQRCode() {
            axios.post(this.$store.getters.getApiUrl('marketing.promo_code.getQRCode'), {
                code: this.element.code,
            }, {
                responseType: 'blob',
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'qrcode.png');
                document.body.appendChild(link);
                link.click();
            })
        },
        generateCode() {
            axios.post(this.$store.getters.getApiUrl('marketing.promo_code.generate'))
                .then(({data}) => {
                    if (data.success) {
                        this.element.code = data.code
                    }
                })
        },
        setExtraDataCreate() {
            this.element.activated = this.selectBooleanOptions.find(el => el.id === true)
        },
        getClass(key) {
            if (['description', 'note'].includes(key)) {
                return 'w50'
            }
            return 'w33'
        },

    },
}
</script>
